import { CFBaseToastTokens } from '..';
export const getMessageColor = ({ alternateTheme, }) => alternateTheme
    ? CFBaseToastTokens.TEXT_COLOR.ALTERNATE
    : CFBaseToastTokens.TEXT_COLOR.DEFAULT;
export const getTitleColor = ({ alternateTheme = false, status = 'message', }) => {
    switch (status) {
        case 'notification-success':
            return alternateTheme
                ? CFBaseToastTokens.TITLE_COLOR.ALTERNATE.SUCCESS
                : CFBaseToastTokens.TITLE_COLOR.DEFAULT.SUCCESS;
        case 'notification-alert':
            return alternateTheme
                ? CFBaseToastTokens.TITLE_COLOR.ALTERNATE.ALERT
                : CFBaseToastTokens.TITLE_COLOR.DEFAULT.ALERT;
        case 'notification-attention':
            return alternateTheme
                ? CFBaseToastTokens.TITLE_COLOR.ALTERNATE.ATTENTION
                : CFBaseToastTokens.TITLE_COLOR.DEFAULT.ATTENTION;
        case 'notification-neutral':
            return alternateTheme
                ? CFBaseToastTokens.TITLE_COLOR.ALTERNATE.NEUTRAL
                : CFBaseToastTokens.TITLE_COLOR.DEFAULT.NEUTRAL;
        case 'message':
        case 'member':
        default:
            return alternateTheme
                ? CFBaseToastTokens.TITLE_COLOR.ALTERNATE.DEFAULT
                : CFBaseToastTokens.TITLE_COLOR.DEFAULT.DEFAULT;
    }
};
